// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serialization for failed ChangeLogEntries.
 * @see #/components/schemas/ChangeLogEntryFailed - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface ChangeLogEntryFailed {
    /**
     * The unique id of ChangeLogEntry.
     * @dataFormat uuid
     */
    id: string;
    /**
     * ChangeLogEntry failed reason.
     *
     */
    reason: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for ChangeLogEntryFailed
 */
export namespace ChangeLogEntryFailed {
    /**
     * ChangeLogEntryFailed Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The unique id of ChangeLogEntry.
         * @dataFormat uuid
         */
        id: string;
        /**
         * ChangeLogEntry failed reason.
         * @type string (`dataFormat` is missing)
         */
        reason: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * ChangeLogEntryFailed DTO
     * Transforms ChangeLogEntryFailed model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend ChangeLogEntryFailed model */
        static toModel(obj: ChangeLogEntryFailed): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend ChangeLogEntryFailed model */
        static toApi(obj: Model): ChangeLogEntryFailed {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as ChangeLogEntryFailed;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
